import {
  CaseFindingPresentationType,
  ConversationQuestionType,
  FindingSource,
  QualifiedFeature,
  QualifiedFeatureFragment,
} from "fe-common/graphql";
import { LegacyQFDriverQuestion } from "./LegacyQFDriverQuestion";

export interface DriverQuestionLogic {
  answer: (qfs: QualifiedFeature[]) => QualifiedFeature[];
}

type DriverQuestionConfig = {
  text?: string;
  group: CaseFindingPresentationType;
  source: FindingSource;
  logicBuilder: () => DriverQuestionLogic;
  qfsConstructor?: (
    qfs: QualifiedFeatureFragment[],
  ) => { [key: string]: QualifiedFeatureFragment[] };
};

export const DriverQuestionsConfig: { [key: string]: DriverQuestionConfig } = {
  [ConversationQuestionType.Gender]: {
    text: "QUESTION_GENDER_NO_NAME",
    group: CaseFindingPresentationType.BackgroundFinding,
    source: FindingSource.Patient,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.Age]: {
    text: "QUESTION_AGE",
    group: CaseFindingPresentationType.BackgroundFinding,
    source: FindingSource.Patient,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.Pregnancy]: {
    group: CaseFindingPresentationType.BackgroundFinding,
    source: FindingSource.Patient,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.VolunteerBackgroud]: {
    text: "Medical History",
    group: CaseFindingPresentationType.BackgroundFinding,
    source: FindingSource.PatientVolunteer,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.VolunteerFamilyHistory]: {
    text: "Family History",
    group: CaseFindingPresentationType.BackgroundFinding,
    source: FindingSource.PatientVolunteer,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.MultipleChiefComplaint]: {
    text: "",
    group: CaseFindingPresentationType.MainFinding,
    source: FindingSource.PatientVolunteer,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.ChiefComplaint]: {
    text: "",
    group: CaseFindingPresentationType.MainFinding,
    source: FindingSource.PatientVolunteer,
    logicBuilder: () => new LegacyQFDriverQuestion(),
    // Since chief complains might have more than one qualifier (since june 23)
    // as a temporary solution we would like to treat the first complaint in the list as the one chief complaint,
    // and put the rest as active presentation type, so it would be supported by the summary.
    qfsConstructor: (qfs) => {
      // If there is only one complaint mark is as main
      if (qfs.length <= 1)
        return { [CaseFindingPresentationType.MainFinding]: qfs };
      return {
        // If we have more than one complaint - first is main, the rest are just active
        [CaseFindingPresentationType.MainFinding]: qfs.slice(0, 1),
        [CaseFindingPresentationType.ActiveFinding]: qfs.slice(1),
      };
    },
  },
  [ConversationQuestionType.Final]: {
    text: "",
    group: CaseFindingPresentationType.ActiveFinding,
    source: FindingSource.PatientVolunteer,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.FreeText]: {
    text: "",
    group: CaseFindingPresentationType.ActiveFinding,
    source: FindingSource.PatientFreeText,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.Duration]: {
    text: "",
    group: CaseFindingPresentationType.ActiveFinding,
    source: FindingSource.Patient,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.BackgroundSuggestion]: {
    text: "",
    group: CaseFindingPresentationType.BackgroundFinding,
    source: FindingSource.Patient,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.InsufficientData]: {
    text: "",
    group: CaseFindingPresentationType.ActiveFinding,
    source: FindingSource.PatientVolunteer,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.OtherComplaint]: {
    text: "",
    group: CaseFindingPresentationType.ActiveFinding,
    source: FindingSource.PatientVolunteer,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.Suggestion]: {
    text: "",
    group: CaseFindingPresentationType.ActiveFinding,
    source: FindingSource.Patient,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.Allergies]: {
    text: "",
    group: CaseFindingPresentationType.BackgroundFinding,
    source: FindingSource.PatientVolunteer,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
  [ConversationQuestionType.Medications]: {
    text: "",
    group: CaseFindingPresentationType.BackgroundFinding,
    source: FindingSource.PatientVolunteer,
    logicBuilder: () => new LegacyQFDriverQuestion(),
  },
};
